import JSEncrypt from "jsencrypt";
import { API_BASE_URL } from "./api-base";
import { getSessionToken, getTokenEpoch, storeSessionToken } from "./token-session";

const BASE_URL = API_BASE_URL;
const PUBLIC_KEY =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDE1pdevaMnKlJ/lE9azAJiNSUAs3l4LrIshBieJN3ozSP2zGreLc4LTbZ9jiZz1JIrhHyxwxtt0pXK3LbOQSQzjl9eFli5z3uqtLLpFy8Fx6XKoOWs5WAY2BXbxdkY4E2YTWIMXUHba7bPrxHnFuACq/yY9YTHAE5OtauKf1YxrQIDAQAB";

const encryptor = new JSEncrypt();
encryptor.setPublicKey(PUBLIC_KEY);

function lang() {
  return localStorage.getItem("U_LANGUAGE") || "en-US";
}

function authHeader() {
  const addr = window.sessionStorage.getItem("ADDRESS");
  if (!addr || addr.length <= 20) return "";

  const encrypted = encryptor.encrypt(`${Date.now()}:${addr}`);
  return encrypted || "";
}

function tokenHeader() {
  return getSessionToken();
}

function normalizeToken(raw) {
  return String(raw || "").trim().replace(/^Bearer\s+/i, "");
}

function readTokenFromObject(obj) {
  if (!obj) return "";
  if (typeof obj === "string") return normalizeToken(obj);
  if (typeof obj !== "object") return "";

  const direct =
    obj.token ||
    obj.accessToken ||
    obj.access_token ||
    obj.jwt ||
    obj.authorization ||
    obj.Authorization ||
    "";
  if (direct) return normalizeToken(direct);

  if (obj.data) {
    const nestedData = readTokenFromObject(obj.data);
    if (nestedData) return nestedData;
  }

  if (obj.result) {
    const nestedResult = readTokenFromObject(obj.result);
    if (nestedResult) return nestedResult;
  }

  return "";
}

function buildHeaders() {
  const authorization = authHeader();
  const token = tokenHeader();

  return {
    "Content-Type": "application/json",
    "Accept-Language": lang(),
    Lang: lang(),
    ...(authorization ? { Authorization: authorization } : {}),
    ...(token ? { token } : {}),
  };
}

async function parseResponse(resp, requestEpoch) {
  if (!resp.ok) {
    throw new Error(`HTTP ${resp.status}`);
  }

  const json = await resp.json();
  const tokenFromBody = readTokenFromObject(json);
  storeSessionToken(resp.headers.get("token") || resp.headers.get("Token"), requestEpoch);
  storeSessionToken(tokenFromBody, requestEpoch);

  if (json && json.time) {
    localStorage.setItem("time", json.time);
  }

  if (json && (Number(json.code) === 200 || Number(json.code) === 1)) {
    return json.data !== undefined ? json.data : json;
  }

  if (json && json.data && typeof json.data === "object") {
    const subCode = Number(json.data.code);
    if (subCode === 200 || subCode === 1) {
      return json.data.data !== undefined ? json.data.data : json.data;
    }
  }

  const msg = (json && (json.msg || json.message)) || "Request failed";
  throw new Error(msg);
}

export async function apiGet(path) {
  const requestEpoch = getTokenEpoch();
  const resp = await fetch(`${BASE_URL}${path}`, {
    method: "GET",
    headers: buildHeaders(),
  });

  return parseResponse(resp, requestEpoch);
}

export async function apiPost(path, body) {
  const requestEpoch = getTokenEpoch();
  const resp = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(body || {}),
  });

  return parseResponse(resp, requestEpoch);
}
